(function () {
  var loader = document.querySelector('script[data-al-i18n-runtime]');
  if (!loader || !loader.dataset) return;

  function decodeEntities(value) {
    var current = String(value || '');
    var textarea = document.createElement('textarea');
    for (var i = 0; i < 8; i += 1) {
      textarea.innerHTML = current;
      var decoded = textarea.value;
      if (decoded === current) break;
      current = decoded;
    }
    return current;
  }

  var labels = {
    shop: decodeEntities(loader.dataset.shopTitle || ''),
    personalization: decodeEntities(loader.dataset.personalizationTitle || ''),
    process: decodeEntities(loader.dataset.processTitle || ''),
    petName: decodeEntities(loader.dataset.petNameLabel || ''),
    petSex: decodeEntities(loader.dataset.petSexLabel || ''),
    male: decodeEntities(loader.dataset.petSexMale || ''),
    female: decodeEntities(loader.dataset.petSexFemale || '')
  };

  var petNameAliases = [
    'Nome', 'Nome do pet',
    "Pet's name", 'Pet’s name',
    'Nombre de la mascota', 'Nombre del animal',
    "Nom de l'animal", 'Nom de l’animal',
    'Name des Haustiers', 'Name des Tieres',
    'Naam van huisdier', 'Naam van het dier'
  ];

  var petSexAliases = [
    'Sexo do pet', "Pet's sex", 'Pet’s sex', 'Sexo del animal',
    "Sexe de l'animal", 'Sexe de l’animal', 'Geschlecht des Tieres', 'Geslacht van het dier'
  ];

  var maleAliases = ['Macho', 'Male', 'Mâle', 'Männlich', 'Mannelijk'];
  var femaleAliases = ['Fêmea', 'Female', 'Hembra', 'Femelle', 'Weiblich', 'Vrouwelijk'];

  function contains(list, value) {
    return list.indexOf(value) !== -1;
  }

  function isPetNameKey(key) {
    if (contains(petNameAliases, key)) return true;
    var lower = String(key || '').toLowerCase();
    return lower.indexOf('pet') !== -1 && lower.indexOf('name') !== -1;
  }

  function isPetSexKey(key) {
    if (contains(petSexAliases, key)) return true;
    var lower = String(key || '').toLowerCase();
    return lower.indexOf('pet') !== -1 && lower.indexOf('sex') !== -1;
  }

  function setLinkLabel(link, label) {
    if (!label || !link) return;
    if (String(link.textContent || '').trim() === label) return;
    var underline = link.querySelector('.al-nav-desktop__underline');
    if (underline) {
      Array.prototype.slice.call(link.childNodes).forEach(function (node) {
        if (node.nodeType === 3) node.remove();
      });
      link.insertBefore(document.createTextNode(label + ' '), underline);
    } else {
      link.textContent = label;
    }
  }

  function localizeNavigation(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('.al-nav-desktop a[href], .al-mobile-nav__panel a[href]').forEach(function (link) {
      var url;
      try {
        url = new URL(link.getAttribute('href'), window.location.origin);
      } catch (error) {
        return;
      }
      var path = url.pathname.replace(/\/+$/, '');
      if (/\/collections\/loja$/.test(path)) {
        setLinkLabel(link, labels.shop);
      } else if (/\/pages\/personalizacao$/.test(path)) {
        setLinkLabel(link, labels.personalization);
      } else if (/\/pages\/processo$/.test(path)) {
        setLinkLabel(link, labels.process);
      }
    });
  }

  function normalizePropertyInput(input) {
    if (!input || !input.getAttribute) return;
    var name = input.getAttribute('name') || '';
    var match = /^properties\[(.*)\]$/.exec(name);
    if (!match) return;

    var key = decodeEntities(match[1]).trim();
    var normalizedKey = key;
    if (isPetNameKey(key) && labels.petName) {
      normalizedKey = labels.petName;
    } else if (isPetSexKey(key) && labels.petSex) {
      normalizedKey = labels.petSex;
    }

    var normalizedName = 'properties[' + normalizedKey + ']';
    if (name !== normalizedName) input.setAttribute('name', normalizedName);
  }

  function normalizePropertyInputs(root) {
    if (!root) return;
    if (root.nodeType === 1 && root.matches && root.matches('[name]')) {
      normalizePropertyInput(root);
    }
    if (root.querySelectorAll) {
      root.querySelectorAll('[name]').forEach(normalizePropertyInput);
    }
  }

  function normalizePropertyPair(key, value) {
    key = decodeEntities(String(key || '').replace(/:\s*$/, '').trim());
    value = decodeEntities(String(value || '').trim());

    if (isPetNameKey(key) && labels.petName) {
      return { key: labels.petName, value: value };
    }

    if (isPetSexKey(key) && labels.petSex) {
      if (contains(maleAliases, value) && labels.male) value = labels.male;
      if (contains(femaleAliases, value) && labels.female) value = labels.female;
      return { key: labels.petSex, value: value };
    }

    return null;
  }

  function localizeCartProperties(root) {
    if (!root || !root.querySelectorAll) return;

    root.querySelectorAll('.al-cart-grid li.al-small').forEach(function (line) {
      var text = String(line.textContent || '').trim();
      var separator = text.indexOf(':');
      if (separator < 0) return;

      var normalized = normalizePropertyPair(text.slice(0, separator), text.slice(separator + 1));
      if (!normalized) return;

      var localizedText = normalized.key + ': ' + normalized.value;
      if (text !== localizedText) line.textContent = localizedText;
    });

    root.querySelectorAll('.cart-items__property').forEach(function (row) {
      var keyNode = row.querySelector('dt');
      var valueNode = row.querySelector('dd');
      if (!keyNode || !valueNode) return;

      var normalized = normalizePropertyPair(keyNode.textContent, valueNode.textContent);
      if (!normalized) return;

      keyNode.textContent = normalized.key + ': ';
      valueNode.textContent = normalized.value;
    });
  }

  function processTree(root) {
    localizeNavigation(root.nodeType === 9 ? root : document);
    normalizePropertyInputs(root);
    localizeCartProperties(root.nodeType === 9 ? root : document);
  }

  function init() {
    processTree(document);

    if ('MutationObserver' in window) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            normalizePropertyInputs(node);
          });
        });
        localizeNavigation(document);
        localizeCartProperties(document);
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
